import { render, staticRenderFns } from "./Salaries.vue?vue&type=template&id=9cc49452&scoped=true"
import script from "./Salaries.vue?vue&type=script&lang=js"
export * from "./Salaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc49452",
  null
  
)

export default component.exports